import api from "../../_core/api";
import { HttpError, failure } from "../../_core/services/toast";
// import { PERMISSIONS_MOCK } from "../../requests/mock";

type UserAccessParams = {
  idUsuario: number;
};

export async function authenticate(): Promise<any> {
  const { data } = await api.get("/userinfo");
  return data;
}

export function handleAuthenticateError(error: unknown): void {
  if (error as HttpError) {
    const err = error as HttpError;
    const { status } = err.response;
    switch (status) {
      case 401:
        failure("Erro: 401 - Usuário e/ou senha inválido(s)");
        break;
      case 403:
        failure("Erro: 403 - Forbidden - (Entre em contato com o suporte");
        break;
      default:
        failure(
          "Erro: 500 - Internal Server Error - (Entre em contato com o suporte"
        );
        break;
    }
    return;
  }
  failure("Erro interno");
}

export async function getUserAccess({
  idUsuario,
}: UserAccessParams): Promise<any> {
  const { data } = await api.post("/perfilizacao/usuario/acessos/buscar", {
    idUsuario,
  });
  // const data = PERMISSIONS_MOCK;
  return data.content;
}
